export const baseUrl = "https://inclusivo-api.el.r.appspot.com"; 
